import React, { useContext, useEffect } from 'react'
import {
    Switch,
    Route,
    Redirect,
    useRouteMatch,
    useParams
} from "react-router-dom";
import { UserContext } from '../../context/provider/UserProvider';

import { Chat } from '../pages/Chat';

import { LayoutMaster } from '../modules/layout/LayoutMaster';
import { PrivateRoute } from '../components/PrivateRoute';
import { Principal } from '../pages/Principal';
import { Login } from '../pages/Login';
import { Grupos } from '../pages/AtencionCliente/Grupos';
import { UsuariosPlataforma } from '../pages/AtencionCliente/UsuariosPlataforma';
import { EnlaceGrupo } from '../pages/AtencionCliente/EnlaceGrupo';

export function PrivateRoutes({ token }) {
    // export function PrivateRoutes() {

    return (
        <>
            {
                token !== '' && localStorage.getItem('currentLocation') != '/'
                && (
                    <LayoutMaster>
                        <Switch>

                            <PrivateRoute path='/login' component={Login} />
                            <PrivateRoute path='/principal' component={Principal}/>
                            <PrivateRoute path='/chat' component={Chat}/>
                            <PrivateRoute path='/grupos' component={Grupos}/>
                            <PrivateRoute path='/usuarios' component={UsuariosPlataforma}/>
                            <PrivateRoute path='/enlaceGrupo' component={EnlaceGrupo}/>
                        </Switch>
                    </LayoutMaster>
                )
            }

        </>
    )
}